import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatIconModule,
    MatChipsModule,
    MatSnackBarModule
  ],
  exports: [
    MatIconModule,
    MatSnackBarModule
  ],
  entryComponents: []
})
export class MaterialModule { }
